/**
 * @public
 */ export var VideoPlatform = /*#__PURE__*/ function(VideoPlatform) {
    VideoPlatform["OVP"] = "OVP";
    VideoPlatform["EXTERNAL"] = "EXTERNAL";
    VideoPlatform["SKYSTORE"] = "SKYSTORE";
    VideoPlatform["SMIL"] = "SMIL";
    VideoPlatform["ONE_APP"] = "ONE_APP";
    return VideoPlatform;
}({})/* | OtherVpiOptions*/ /**
 * @public
 */ /**
 * @public
 */ /**
     * @deprecated use the request options via parameter in playout request or update service configs by re-instantiating the service
     */ ;

//# sourceMappingURL=integration-provider.js.map